<template>

  <div class="container" v-cloak>
    <div class="main-in">
      <div is='titlebox' :nav='JSON.parse(nav)'></div>
      <div class="content f-row-start-l align-start">
        <div class="box-l">
          <div class="headbox">书库目录</div>
          <div class="headitem_box" v-if='list.length>0'>
            <div @click="onLeft(i)" v-for="(item, i) in list" :key="i" class="overf-elli headitem pinter" :class="act==i?'head_act':''">
              {{item.title|| ''}}
            </div>
          </div>
        </div>
        <div class="box-r ">
            <div class="item-w f-row-start-l align-start wrap min-h">
              <div v-for="(item, i) in bookes" :key="i" :title="item.bookName"
                  @click="Xx(item)" class="pinter act-h f-row-start-l align-start itembox">
                <!-- <div class="triangle"></div> -->
                <el-image class="item-l" fit='cover' :src='$fileAccessHttpUrl(item.bookCover)'></el-image>
                <div class="item-r">
                  <div class="line2">{{ item.bookName||''}}</div>
                  <div class="name">作 (编) 者：{{ item.author|| '' }}</div>
                </div>
                
              </div>
            </div>

            <!-- 分页 -->
            <div class="block f-row-l">
              <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNo"
                  :page-size="pageSize"
                  layout="prev, pager, next, jumper"
                  :total="total">
              </el-pagination>
            </div>
        </div>
      </div>

       
       
    </div>
    
  </div>

</template>
<script>

export default {
  computed: {
    nav: function () {
      var tier = 1;
      var type = this.$route.query.type
      if ((type >= 14) && (type <= 32) && type != 24 && type != 31) {
        tier = 2
      }
      if ((type >= 36) && (type <= 48)) {
        tier = 2
      }
      var arr = this.$util.getTopNav(this.title, this.$route.query.type, this.$route.query.isPrivate, tier)
      return JSON.stringify(arr)
    }
  },
  data() {
    return {
      list:[],
      act: 0,
      type: this.$route.query.type,
      title: '',
      pageNo: 1,//分页
      pageSize: 8,
      total: 0,
      bookes:[],
    }
  },
  mounted() {
    this.typeIs();
    
  },
  watch: {
    $route(to, from, next) {
      if (to.path.indexOf('/news') != -1) {
        this.type = this.$route.query.type;
        this.pageNo = 1
        this.typeIs();
      }
    },
  },
  methods: {
    onLeft(i){
      this.act=i;
      this.pageNo=1
      this.getLists()
    },
    getSys(){//sys/dict/getDictItems/bookCatalogue
      var that=this;
      this.$get('/sys/dict/getDictItems/book_catalogue').then(res => {
        that.list=res.result
        that.getLists();
      })
    },
    typeIs() {
      this.material = [];
      this.title = this.$util.getTitle(this.type)
      //党建服务》学习书库
      // this.param.msgType = 12
      this.getSys();
    },
   
    handleSizeChange(val) {
      this.$util.goTop()
      this.pageSize = val;
      this.getLists();
    },
    handleCurrentChange(val) {
      this.$util.goTop()
      this.pageNo = val;
      this.getLists();
    },
    Xx(item) {
      this.$util.goTop()
      // this.$router.push(`/newDetail?type=${this.type}&id=${item.id}`);
      window.open(item.linkHref)
    },
    getLists() {//
      this.bookes = []
      var param={
        pageNo: this.pageNo,//分页
        pageSize:this.pageSize,
        bookCatalogue:this.list.length>0?this.list[this.act].value:''
      };
      this.$get('/web/studyLibrary/list', param).then(res => {
        this.bookes = res.result.records;
        this.total = res.result.total
      })
    },
  },


}
</script>
<style lang="scss" scoped>
.content {
  margin-top: 53px;
  align-items:stretch;
  .box-l{ 
    width: 260px;
    font-size: 18px;
    margin-bottom: 100px;
    .headbox,.headitem{
      width: 100%;
      padding: 0px 10px;
      height: 56px;
      line-height: 56px;
      text-align: left;
      box-sizing: border-box;
      font-weight: normal;
    }
    .headbox{
      background: #BA0711;
      color: #ffffff;
      box-shadow: 0px 0px 1px #BA0711;
    }
    .headitem_box{ 
      box-shadow: 0px 1px 2px #cccccc;
      .headitem{
        color: #333333;
      }
      .head_act{
        color: #9B2A25;
        position: relative;
        background: #EFEFEF;
      }
      .head_act::before{
        position: absolute;
        content: '';
        left: 0px;
        height: 56px;
        width: 2px;
        background: #9B2A25;
      }
    }
    
  }
  .box-r{
    // height: 100%;
    width: calc(100% - 340px);
    position: relative;
    .item-w{
      width: 100%;
      padding-left: 40px;
      padding-bottom: 90px;
      box-sizing: border-box;
    }
    // 
    .itembox {
      width:calc(50% - 30px);
      margin-left: 60px;
      list-style: none;
      text-align: left;
      line-height: 25px;
      margin-bottom: 70px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      position: relative;
      .item-l{
        width: 151px;
        height: 190px;
        box-shadow: 0px 4px 12px 0px #AFAFAF;
      }
      .item-r{
        width: calc(100% - 171px);
        margin-left: 20px;
        line-height: 34px;
        padding-top: 10px;
        // font-size: 20px;
        font-size: 18px;
        font-weight: normal;
        font-family: Adobe Heiti Std;
        .line2{
          color: #333333;
        }
      }
      .name {
        color: #666666;
        padding-top: 30px;
      }
    }
    .itembox:nth-child(2n+1){
      margin-left: 0px;
    }
  }
  
}
.block {
    width: 100%;
    height: 32px;
    bottom: 30px;
    left: 30px;
    position: absolute;
}
</style>
